import { _toReference } from "@common/helpers/utils";
import { BaseModel } from "./common.model";
import { ProjectModel } from "./project.model";

export interface ExerciseModel extends BaseModel{
  status: 'draft';
  period: Date;
  project: ProjectModel.Ref;
  currency: string;
  areaUnit:'ha';
  ecosystems:Array<ExerciseModel.Ecosystem>;
  cumulativeGains:AmountPv60;
  revaluations: AmountPv60;
  additions: AmountPv60;
}

export interface AmountPv60{
  value:number;
  pv60:number;
  note:string;
}

export namespace ExerciseModel{


  export interface EcoService{

  }
  export interface Ecosystem {
    id:string;
    name:string;
    area: number;
    condtion?:ConditionType;
    note: string;
  }

  export const CONDITIONS = [
    'veryGood',
    'good',
    'moderate',
    'poor',
    'veryPoor',
    'na',
    // null
  ];
  export type ConditionType = typeof CONDITIONS[number];

  export type Ref = Pick<ExerciseModel, 'id' | 'period' |'project'>
  export const genRef = (_object: ExerciseModel) => _toReference(['id', 'period', 'project'], _object);
}




//Refrencias
//https://ec.europa.eu/environment/nature/capital_accounting/pdf/MAES_INCA_2019_report_FINAL-fpub.pdf

